unit View.Funcionarios.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewFuncionariosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbtelefone1: TLabel;
    edtelefone1: TDBEdit;
    lbtelefone2: TLabel;
    edtelefone2: TDBEdit;
    lbemail: TLabel;
    edemail: TDBEdit;
    lbcadastro: TLabel;
    edcadastro: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFuncionariosGet: TXDataWebClient;
    XDataClientFuncionariosDelete: TXDataWebClient;
    FuncionariosDataset: TXDataWebDataSet;
    FuncionariosDatasetid: TIntegerField;
    FuncionariosDatasetaliado_id: TIntegerField;
    FuncionariosDatasetdata_base_id: TIntegerField;
    FuncionariosDatasetnome: TStringField;
    FuncionariosDatasettelefone1: TStringField;
    FuncionariosDatasettelefone2: TStringField;
    FuncionariosDatasetemail: TStringField;
    FuncionariosDatasetcadastro: TDateTimeField;
    FuncionariosDatasetstatus: TIntegerField;
    FuncionariosDatasetcodigo_interno: TIntegerField;
    FuncionariosDatasetexcluido: TBooleanField;
    FuncionariosDatasetinclusao: TDateTimeField;
    FuncionariosDatasetalteracao: TDateTimeField;
    FuncionariosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientFuncionariosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientFuncionariosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientFuncionariosDeleteError(Error: TXDataClientError);
    procedure FuncionariosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFuncionariosEdit: TFViewFuncionariosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFuncionariosEdit }

procedure TFViewFuncionariosEdit.btSaveClick(Sender: TObject);
begin
  if FuncionariosDataset.State in dsEditModes then
  begin
        FuncionariosDataset.Post;
    FuncionariosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewFuncionariosEdit.btDeleteClick(Sender: TObject);
begin
  if FuncionariosDataset.State in dsEditModes then
    FuncionariosDataset.Post;
  XDataClientFuncionariosDelete.Delete(FuncionariosDataset.EntitySetName,
    TJSObject(FuncionariosDataset.CurrentData));
end;


class function TFViewFuncionariosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFuncionariosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewFuncionariosEdit.InsertEntity;
begin
  FuncionariosDataset.Close;
  FuncionariosDataset.SetJsonData('{}');
  FuncionariosDataset.Open;
  FuncionariosDataset.Insert;
end;

class function TFViewFuncionariosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFuncionariosEdit(AForm).FInserting := AInserting;
    TFViewFuncionariosEdit(AForm).FId := AId;
    TFViewFuncionariosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFuncionariosEdit(AForm).InsertEntity
    else
      TFViewFuncionariosEdit(AForm).LoadEntity;
    TFViewFuncionariosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewFuncionariosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFuncionariosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    FuncionariosDataset.Connection.Model.DefaultSchema.FindEntityType(
      FuncionariosDataset.EntitySetName
    )
  );
  XDataClientFuncionariosGet.Get(FuncionariosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewFuncionariosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewFuncionariosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewFuncionariosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewFuncionariosEdit.XDataClientFuncionariosGetLoad(Response: TXDataClientResponse);
begin
  FuncionariosDataset.Close;
  FuncionariosDataset.SetJsonData(Response.Result);
  FuncionariosDataset.Open;
  
  FuncionariosDataset.Edit;  
end;

procedure TFViewFuncionariosEdit.XDataClientFuncionariosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewFuncionariosEdit.XDataClientFuncionariosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewFuncionariosEdit.FuncionariosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewFuncionariosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFuncionariosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.funcionarios.form.message');
  lbMessage := TLabel.Create('view.funcionarios.form.message.label');
  btCloseMessage := TButton.Create('view.funcionarios.form.message.button');
  btCancel := TButton.Create('view.funcionarios.form.btBack');
  btSave := TButton.Create('view.funcionarios.form.btSave');
  btDelete := TButton.Create('view.funcionarios.form.btDelete');
  lbid := TLabel.Create('view.funcionarios.form.lbid');
  edid := TDBEdit.Create('view.funcionarios.form.edid');
  lbaliado_id := TLabel.Create('view.funcionarios.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.funcionarios.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.funcionarios.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.funcionarios.form.eddata_base_id');
  lbnome := TLabel.Create('view.funcionarios.form.lbnome');
  ednome := TDBEdit.Create('view.funcionarios.form.ednome');
  lbtelefone1 := TLabel.Create('view.funcionarios.form.lbtelefone1');
  edtelefone1 := TDBEdit.Create('view.funcionarios.form.edtelefone1');
  lbtelefone2 := TLabel.Create('view.funcionarios.form.lbtelefone2');
  edtelefone2 := TDBEdit.Create('view.funcionarios.form.edtelefone2');
  lbemail := TLabel.Create('view.funcionarios.form.lbemail');
  edemail := TDBEdit.Create('view.funcionarios.form.edemail');
  lbcadastro := TLabel.Create('view.funcionarios.form.lbcadastro');
  edcadastro := TDBEdit.Create('view.funcionarios.form.edcadastro');
  lbstatus := TLabel.Create('view.funcionarios.form.lbstatus');
  edstatus := TDBEdit.Create('view.funcionarios.form.edstatus');
  lbcodigo_interno := TLabel.Create('view.funcionarios.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.funcionarios.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.funcionarios.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.funcionarios.form.edexcluido');
  lbinclusao := TLabel.Create('view.funcionarios.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.funcionarios.form.edinclusao');
  lbalteracao := TLabel.Create('view.funcionarios.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.funcionarios.form.edalteracao');
  lbexclusao := TLabel.Create('view.funcionarios.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.funcionarios.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  FuncionariosDataset := TXDataWebDataSet.Create(Self);
  FuncionariosDatasetid := TIntegerField.Create(Self);
  FuncionariosDatasetaliado_id := TIntegerField.Create(Self);
  FuncionariosDatasetdata_base_id := TIntegerField.Create(Self);
  FuncionariosDatasetnome := TStringField.Create(Self);
  FuncionariosDatasettelefone1 := TStringField.Create(Self);
  FuncionariosDatasettelefone2 := TStringField.Create(Self);
  FuncionariosDatasetemail := TStringField.Create(Self);
  FuncionariosDatasetcadastro := TDateTimeField.Create(Self);
  FuncionariosDatasetstatus := TIntegerField.Create(Self);
  FuncionariosDatasetcodigo_interno := TIntegerField.Create(Self);
  FuncionariosDatasetexcluido := TBooleanField.Create(Self);
  FuncionariosDatasetinclusao := TDateTimeField.Create(Self);
  FuncionariosDatasetalteracao := TDateTimeField.Create(Self);
  FuncionariosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientFuncionariosGet := TXDataWebClient.Create(Self);
  XDataClientFuncionariosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbtelefone1.BeforeLoadDFMValues;
  edtelefone1.BeforeLoadDFMValues;
  lbtelefone2.BeforeLoadDFMValues;
  edtelefone2.BeforeLoadDFMValues;
  lbemail.BeforeLoadDFMValues;
  edemail.BeforeLoadDFMValues;
  lbcadastro.BeforeLoadDFMValues;
  edcadastro.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  FuncionariosDataset.BeforeLoadDFMValues;
  FuncionariosDatasetid.BeforeLoadDFMValues;
  FuncionariosDatasetaliado_id.BeforeLoadDFMValues;
  FuncionariosDatasetdata_base_id.BeforeLoadDFMValues;
  FuncionariosDatasetnome.BeforeLoadDFMValues;
  FuncionariosDatasettelefone1.BeforeLoadDFMValues;
  FuncionariosDatasettelefone2.BeforeLoadDFMValues;
  FuncionariosDatasetemail.BeforeLoadDFMValues;
  FuncionariosDatasetcadastro.BeforeLoadDFMValues;
  FuncionariosDatasetstatus.BeforeLoadDFMValues;
  FuncionariosDatasetcodigo_interno.BeforeLoadDFMValues;
  FuncionariosDatasetexcluido.BeforeLoadDFMValues;
  FuncionariosDatasetinclusao.BeforeLoadDFMValues;
  FuncionariosDatasetalteracao.BeforeLoadDFMValues;
  FuncionariosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientFuncionariosGet.BeforeLoadDFMValues;
  XDataClientFuncionariosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewFuncionariosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 643;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 583;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 583;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 583;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbtelefone1.SetParentComponent(Self);
    lbtelefone1.Name := 'lbtelefone1';
    lbtelefone1.Left := 24;
    lbtelefone1.Top := 300;
    lbtelefone1.Width := 14;
    lbtelefone1.Height := 13;
    lbtelefone1.Caption := 'telefone1:';
    lbtelefone1.Transparent := True;
    edtelefone1.SetParentComponent(Self);
    edtelefone1.Name := 'edtelefone1';
    edtelefone1.Left := 221;
    edtelefone1.Top := 297;
    edtelefone1.Width := 200;
    edtelefone1.Height := 21;
    edtelefone1.Enabled := True;
    edtelefone1.TabOrder := 10;
    edtelefone1.Text := 'edtelefone1';
    edtelefone1.DataField := 'telefone1';
    edtelefone1.DataSource := DataSource;
    lbtelefone2.SetParentComponent(Self);
    lbtelefone2.Name := 'lbtelefone2';
    lbtelefone2.Left := 24;
    lbtelefone2.Top := 327;
    lbtelefone2.Width := 14;
    lbtelefone2.Height := 13;
    lbtelefone2.Caption := 'telefone2:';
    lbtelefone2.Transparent := True;
    edtelefone2.SetParentComponent(Self);
    edtelefone2.Name := 'edtelefone2';
    edtelefone2.Left := 221;
    edtelefone2.Top := 324;
    edtelefone2.Width := 200;
    edtelefone2.Height := 21;
    edtelefone2.Enabled := True;
    edtelefone2.TabOrder := 11;
    edtelefone2.Text := 'edtelefone2';
    edtelefone2.DataField := 'telefone2';
    edtelefone2.DataSource := DataSource;
    lbemail.SetParentComponent(Self);
    lbemail.Name := 'lbemail';
    lbemail.Left := 24;
    lbemail.Top := 354;
    lbemail.Width := 14;
    lbemail.Height := 13;
    lbemail.Caption := 'email:';
    lbemail.Transparent := True;
    edemail.SetParentComponent(Self);
    edemail.Name := 'edemail';
    edemail.Left := 221;
    edemail.Top := 351;
    edemail.Width := 200;
    edemail.Height := 21;
    edemail.Enabled := True;
    edemail.TabOrder := 12;
    edemail.Text := 'edemail';
    edemail.DataField := 'email';
    edemail.DataSource := DataSource;
    lbcadastro.SetParentComponent(Self);
    lbcadastro.Name := 'lbcadastro';
    lbcadastro.Left := 24;
    lbcadastro.Top := 381;
    lbcadastro.Width := 14;
    lbcadastro.Height := 13;
    lbcadastro.Caption := 'cadastro:';
    lbcadastro.Transparent := True;
    edcadastro.SetParentComponent(Self);
    edcadastro.Name := 'edcadastro';
    edcadastro.Left := 221;
    edcadastro.Top := 378;
    edcadastro.Width := 200;
    edcadastro.Height := 21;
    edcadastro.Enabled := True;
    edcadastro.TabOrder := 13;
    edcadastro.Text := 'edcadastro';
    edcadastro.DataField := 'cadastro';
    edcadastro.DataSource := DataSource;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 24;
    lbstatus.Top := 408;
    lbstatus.Width := 14;
    lbstatus.Height := 13;
    lbstatus.Caption := 'status:';
    lbstatus.Transparent := True;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 221;
    edstatus.Top := 405;
    edstatus.Width := 200;
    edstatus.Height := 21;
    edstatus.Enabled := True;
    edstatus.TabOrder := 14;
    edstatus.Text := 'edstatus';
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 435;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 432;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 15;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 462;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 459;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 16;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 489;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 486;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 17;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 516;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 513;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 18;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 543;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 540;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 19;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := FuncionariosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    FuncionariosDataset.SetParentComponent(Self);
    FuncionariosDataset.Name := 'FuncionariosDataset';
    FuncionariosDataset.AfterApplyUpdates := FuncionariosDatasetAfterApplyUpdates;
    FuncionariosDataset.EntitySetName := 'Funcionarios';
    FuncionariosDataset.Connection := DMConnection.ApiConnection;
    FuncionariosDataset.Left := 176;
    FuncionariosDataset.Top := 8;
    FuncionariosDatasetid.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetid.Name := 'FuncionariosDatasetid';
    FuncionariosDatasetid.FieldName := 'id';
    FuncionariosDatasetid.Required := True;
    FuncionariosDatasetaliado_id.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetaliado_id.Name := 'FuncionariosDatasetaliado_id';
    FuncionariosDatasetaliado_id.FieldName := 'aliado_id';
    FuncionariosDatasetaliado_id.Required := True;
    FuncionariosDatasetdata_base_id.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetdata_base_id.Name := 'FuncionariosDatasetdata_base_id';
    FuncionariosDatasetdata_base_id.FieldName := 'data_base_id';
    FuncionariosDatasetdata_base_id.Required := True;
    FuncionariosDatasetnome.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetnome.Name := 'FuncionariosDatasetnome';
    FuncionariosDatasetnome.FieldName := 'nome';
    FuncionariosDatasetnome.Required := True;
    FuncionariosDatasetnome.Size := 255;
    FuncionariosDatasettelefone1.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasettelefone1.Name := 'FuncionariosDatasettelefone1';
    FuncionariosDatasettelefone1.FieldName := 'telefone1';
    FuncionariosDatasettelefone1.Required := False;
    FuncionariosDatasettelefone1.Size := 255;
    FuncionariosDatasettelefone2.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasettelefone2.Name := 'FuncionariosDatasettelefone2';
    FuncionariosDatasettelefone2.FieldName := 'telefone2';
    FuncionariosDatasettelefone2.Required := False;
    FuncionariosDatasettelefone2.Size := 255;
    FuncionariosDatasetemail.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetemail.Name := 'FuncionariosDatasetemail';
    FuncionariosDatasetemail.FieldName := 'email';
    FuncionariosDatasetemail.Required := False;
    FuncionariosDatasetemail.Size := 255;
    FuncionariosDatasetcadastro.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetcadastro.Name := 'FuncionariosDatasetcadastro';
    FuncionariosDatasetcadastro.FieldName := 'cadastro';
    FuncionariosDatasetcadastro.Required := False;
    FuncionariosDatasetstatus.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetstatus.Name := 'FuncionariosDatasetstatus';
    FuncionariosDatasetstatus.FieldName := 'status';
    FuncionariosDatasetstatus.Required := True;
    FuncionariosDatasetcodigo_interno.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetcodigo_interno.Name := 'FuncionariosDatasetcodigo_interno';
    FuncionariosDatasetcodigo_interno.FieldName := 'codigo_interno';
    FuncionariosDatasetcodigo_interno.Required := True;
    FuncionariosDatasetexcluido.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetexcluido.Name := 'FuncionariosDatasetexcluido';
    FuncionariosDatasetexcluido.FieldName := 'excluido';
    FuncionariosDatasetexcluido.Required := False;
    FuncionariosDatasetinclusao.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetinclusao.Name := 'FuncionariosDatasetinclusao';
    FuncionariosDatasetinclusao.FieldName := 'inclusao';
    FuncionariosDatasetinclusao.Required := False;
    FuncionariosDatasetalteracao.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetalteracao.Name := 'FuncionariosDatasetalteracao';
    FuncionariosDatasetalteracao.FieldName := 'alteracao';
    FuncionariosDatasetalteracao.Required := False;
    FuncionariosDatasetexclusao.SetParentComponent(FuncionariosDataset);
    FuncionariosDatasetexclusao.Name := 'FuncionariosDatasetexclusao';
    FuncionariosDatasetexclusao.FieldName := 'exclusao';
    FuncionariosDatasetexclusao.Required := False;
    XDataClientFuncionariosGet.SetParentComponent(Self);
    XDataClientFuncionariosGet.Name := 'XDataClientFuncionariosGet';
    XDataClientFuncionariosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFuncionariosGet, Self, 'OnLoad', 'XDataClientFuncionariosGetLoad');
    XDataClientFuncionariosGet.Left := 64;
    XDataClientFuncionariosGet.Top := 8;
    XDataClientFuncionariosDelete.SetParentComponent(Self);
    XDataClientFuncionariosDelete.Name := 'XDataClientFuncionariosDelete';
    XDataClientFuncionariosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFuncionariosDelete, Self, 'OnLoad', 'XDataClientFuncionariosDeleteLoad');
    SetEvent(XDataClientFuncionariosDelete, Self, 'OnError', 'XDataClientFuncionariosDeleteError');
    XDataClientFuncionariosDelete.Left := 64;
    XDataClientFuncionariosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbtelefone1.AfterLoadDFMValues;
    edtelefone1.AfterLoadDFMValues;
    lbtelefone2.AfterLoadDFMValues;
    edtelefone2.AfterLoadDFMValues;
    lbemail.AfterLoadDFMValues;
    edemail.AfterLoadDFMValues;
    lbcadastro.AfterLoadDFMValues;
    edcadastro.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    FuncionariosDataset.AfterLoadDFMValues;
    FuncionariosDatasetid.AfterLoadDFMValues;
    FuncionariosDatasetaliado_id.AfterLoadDFMValues;
    FuncionariosDatasetdata_base_id.AfterLoadDFMValues;
    FuncionariosDatasetnome.AfterLoadDFMValues;
    FuncionariosDatasettelefone1.AfterLoadDFMValues;
    FuncionariosDatasettelefone2.AfterLoadDFMValues;
    FuncionariosDatasetemail.AfterLoadDFMValues;
    FuncionariosDatasetcadastro.AfterLoadDFMValues;
    FuncionariosDatasetstatus.AfterLoadDFMValues;
    FuncionariosDatasetcodigo_interno.AfterLoadDFMValues;
    FuncionariosDatasetexcluido.AfterLoadDFMValues;
    FuncionariosDatasetinclusao.AfterLoadDFMValues;
    FuncionariosDatasetalteracao.AfterLoadDFMValues;
    FuncionariosDatasetexclusao.AfterLoadDFMValues;
    XDataClientFuncionariosGet.AfterLoadDFMValues;
    XDataClientFuncionariosDelete.AfterLoadDFMValues;
  end;
end;

end.
